import React, { useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import "./Home.css";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

const Home = ({ onLogin }) => {
    const navigate = useNavigate();
    const { user } = useAuth();

    useEffect(() => {
        if (user?.email) {
            const username = user.email.split("@")[0];
            navigate(`/community/${username}`);
        }
    }, [user, navigate]);

    return (
        <div className="home-container">

            {!user && (
                <div className="login-wrapper">
                    <div className="login-card">
                        <div className="icon">
                            <ShieldCheck size={36} />
                        </div>

                        <h1>Traders Login</h1>
                        <p className="subtitle">Sign in to manage your stock portfolio</p>

                        <button
                            className="google-btn"
                            onClick={onLogin}
                        >
                            <img
                                src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                                alt="Google"
                            />
                            Sign in with Google
                        </button>

                        <div className="info">
                            <p>Only authorized users can create portfolio tracker.</p>
                            <p className="muted">
                                Your Google account will be used for authentication.
                            </p>
                        </div>
                        <div className="page-actions">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => navigate("/community")}
                            >
                                View Community Trades
                            </button>
                        </div>

                    </div>
                </div>
            )}

        </div>
    );
};

export default Home;
